import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	popover: {
		maxWidth: "300px",
		backgroundColor: newColors.grey[0],
		padding: 16,
		border: "1px solid",
		boxShadow: "none",
		borderColor: newColors.grey[200]
	},
	popoverTitle: {
		fontSize: "16px",
		fontWeight: 700
	}
}))

export default useStyles
